import React from 'react';
import { useEffect } from "react";
import './App.css';
import Header from './Header';
import Home from './Home';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Checkout from './Checkout';
import Login from './Login';
import { auth } from "./firebase";
import { useStateValue } from './StateProvider';
import Footer from './Footer';
import ReturnPolicy from './ReturnPolicy';
import ProDetails from './ProDetails';


function App() {

  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      console.log('THE USER IS ', authUser);
    
    if (authUser) {
      // user logged in
      dispatch ({
        type: 'SET_USER',
        user: authUser
      })
    } else { 
      // user is logged out
      dispatch({
        type: 'SET_USER',
        user: null
      })
    }
    })
  }, [])


  return (
    <Router>
      <div className="app">
        <Switch>
        <Route path="/login">
            <Login/>
          </Route>
          <Route path="/checkout">
            <Header/>
            <Checkout/>
          </Route>
          <Route path="/return">
            <Header/>
            <ReturnPolicy/>
          </Route>
          <Route path="/product-details">
            <Header/>
            <ProDetails/>
          </Route>
          <Route path="/">
            <Header/>
            <Home />
          </Route>
        </Switch>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
